/**
 * GTM est désormais chargé directement depuis `index.html` avec Google Consent Mode v2,
 * ce qui est plus performant et conforme RGPD/CNIL.
 *
 * Le consentement est mis à jour via `updateGTMConsent()` dans `useCookieConsent.tsx`,
 * qui pousse un event `consent_update` au dataLayer (déclencheur GTM `CE - consent_update`).
 *
 * Ce composant est conservé comme no-op pour préserver les imports existants.
 */
export const GoogleTagManager = () => null;

declare global {
  interface Window {
    dataLayer: any[];
  }
}
